module.exports = __webpack_public_path__ + "static/55-11b95c0546c27aaa25bbb87d4457f587.png";